import { render } from "./SaleSummaryIncomeProgressCard.vue?vue&type=template&id=56cf3d03"
import script from "./SaleSummaryIncomeProgressCard.vue?vue&type=script&lang=js"
export * from "./SaleSummaryIncomeProgressCard.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__